import React from 'react';

const ItemCard = ({ item, generateBrandColor, onEdit, onDelete, isCompact = false }) => {
  const handleDelete = async (itemToDelete) => {
    if (confirm(`确定要删除"${itemToDelete.brand} - itemToDelete.name}"吗？`)) {
      try {
        const { db } = await import('../supabaseClient');
        
        // 删除物品：使用 TEXT 类型的 id
        const result = await db.deleteItem(itemToDelete.id);
        
        if (result.error) {
          console.error('删除失败:', result.error);
          alert('删除失败: ' + result.error.message);
          return;
        }
        
        // 调用父组件的删除回调来更新 UI
        if (onDelete) {
          onDelete(itemToDelete.id);
        }
        
        console.log('删除成功:', itemToDelete);
      } catch (error) {
        console.error('删除出错:', error);
        alert('删除出错: ' + error.message);
      }
    }
  };

  return (
    <div 
      className={`rounded-lg p-3 border transition-all cursor-pointer hover:shadow-md ${
        isCompact ? 'mb-2' : 'mb-4'
      }`}
      style={{ 
        backgroundColor: '#1F1F1F',
        borderLeft: `4px solid ${generateBrandColor(item.brand)}`,
        border: '1px solid #2D2D2D'
      }}
      onClick={() => onEdit(item)}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <div className="font-medium text-white truncate">
            {item.brand || '未知品牌'}
          </div>
          <div className="text-sm text-gray-400 truncate">
            {item.name || '未命名物品'}
          </div>
        </div>
        
        <div className="flex items-center space-x-2 ml-3">
          {item.is_favorite && (
            <span className="text-yellow-500">★</span>
          )}
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleDelete(item);
            }}
            className="text-gray-500 hover:text-red-400 transition-colors"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default ItemCard;
